import { DotsMenuIcon } from 'de-suite-me-ui'

export default DotsMenuIcon
